<template>
  <div class="quick-view-modal">
    <div class="main-content" v-if="categories.length">
      <div class="left-part">
        <div class="header" v-if="!categories">
          <div class="loader">{{ _T('Loading') }}..</div>
        </div>
        <div class="header" v-else>
          <span>{{ _T('our menus') }}</span>
        </div>
        <ul v-if="categories">
          <li
            v-for="(category, key) in categories"
            :key="key"
            :class="{
              active: activeCategory
                ? activeCategory._id === category._id
                : false,
            }"
          >
            <a href="javascript:void(0)" @click="getItems(category)">
              {{ _T_DB(category, 'name') }}
            </a>
          </li>
        </ul>
        <div v-if="categorySlice < categoriesLength" class="footer">
          <router-link
            class="middle-content"
            :to="{
              name: brandStoreRoute('store_page'),
              params: {
                brand_id: set_website_slug(selectedBrandData),
                store_id: store_slug,
              },
            }"
          >
            <span>
              {{ categoriesLength - categorySlice + ' ' + _T('more') }}</span
            >
          </router-link>
        </div>
      </div>
      <div class="right-part">
        <div class="quickview-loader" v-if="!loader">
          <div class="loader"></div>
        </div>
        <div data-class="popular" class="row quick-modal active ratio_94">
          <div
            class="col-xl-4"
            v-for="(item, index) in activeCategoryItems"
            :key="index"
          >
            <div class="product-detail-box" @click="path_is(item, 'item')" @mouseover="path_is(item, 'item')">
              <router-link
                :to="{
                  path: item_path,
                }"
                class="img-box"
              >
                <div>
                  <div
                    v-bind:style="{ 'background-image': `url(${item.image})` }"
                    v-if="item.image"
                    class="bg-size"
                  ></div>
                  <div
                    v-else
                    :style="{
                      'background-color': item.item_color
                        ? item.item_color
                        : '#f02',
                    }"
                    class="bg-size"
                  ></div>
                </div>
                <div class="slider-label tertiary">
                  <span class="text-uppercase">{{ item.item_type }}</span>
                </div>
              </router-link>
              <div class="product-details">
                <a>
                  <h5 :title="_T_DB(item, 'name')">{{ _T_DB(item, 'name') }}</h5>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="main-content"
      :class="{ 'loader-main-content': !categories }"
      v-else
    >
      <div class="quickview-loader" v-if="!categories">
        <div class="loader"></div>
      </div>
      <div class="not-found-inner" v-else>
        <img class="img-fluid" src="/images/sad.png" alt="" />
        <div class="d-block mt-3">
          <h4>{{ _T('No items found') }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import { seo_name } from '@/utils/main_utils'
export default {
  name: 'QuickView',
  data () {
    return {
      // activeCategoryItems: false,
      categorySlice: 5,
      activeCategory: false,
      item_path: ''
    }
  },
  /*updated() {
        this.categorySlice = 5
    },*/
  watch: {
    categories (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.activeCategory = newVal[0]
        })
      }
    },
  },
  computed: {
    ...mapState({
      quickView: state => state.brand_store.quickView,
      loader: state => state.brand_store.quickLoader,
    }),
    ...mapGetters([
      'selectedBrandData',
      'brandWiseStores',
      'brandStoreRoute',
      'set_website_slug',
      'quickViewDetails',
      'currentDeliveryArea',
    ]),
    firstStore () {
      if (this.selectedBrandData && this.brandWiseStores[0]) {
        return this.set_website_slug(this.brandWiseStores[0])
      }
      return false
    },
    items () {
      return this.quickView.items
    },
    categoriesLength () {
      if (!this.quickView.categories) return 0

      return this.quickView.categories.length
    },
    categories () {
      if (!this.quickView.categories) return false
      return this.quickView.categories.slice(0, this.categorySlice)
    },
    brand_store () {
      if (!this.quickView.data) return false
      return this.quickView.data
    },
    store_slug () {
      if (this.brand_store) {
        let store = this.brandWiseStores.find(store => store._id === this.brand_store.store_id)
        if (store) {
          return this.set_website_slug(store)
        }
      }
      return this.firstStore
    },
    /*activeCategory() {
      return this.quickView.selected_cat || false
    },*/
    activeCategoryItems () {
      if (!this.quickView.selected_cat) return false
      if (this.activeCategory) {
        let items = this.items.filter(
          item => item.category === this.activeCategory._id
        )
        return items.slice(0, 6)
      }
      return this.quickView.selected_cat.slice(0, 6)
    },
    ...mapGetters(['_T', '_T_DB']),
  },
  methods: {
    path_is(item, related) {
      let delivery_area = this.currentDeliveryArea
      let path = `/${this.set_website_slug(this.selectedBrandData)}/store/${this.store_slug}`
      if (!item) return false
      if (related === 'category') {
        path += '/category/' + item.slug
      } /*else {
        if (item.category && this.quickViewDetails) {
          let category = this.quickViewDetails.categories.find(category => category._id === item.category)
          let category_name = category.slug
          path += '/category/' + category_name
        }
      }*/
      if (item.slug) {
        this.$store.commit('SELECT_MODIFIERS', {})
        this.$store.commit('SELECT_ITEM', item)
        this.$store.commit('PRODUCT_DETAILS_PAGE', true)
        path = `/${this.set_website_slug(this.selectedBrandData)}/${this.store_slug}/product/${item.slug}`
      }
      this.item_path = path + `/${delivery_area}`
    },
    getItems (category) {
      this.activeCategory = category
      this.path_is(category, 'category')
    },
    moreCategories (viewMore) {
      this.categorySlice += viewMore
    },
    seoName (name) {
      return seo_name(name)
    },
  },
  mounted () {
    this.activeCategory = this.categories[0]
  },
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .quick-view-modal {
    .main-content {
      .left-part ul {
        padding-left: unset;
        padding-right: 0;
      }
      .right-part {
        margin-left: unset;
        margin-right: 1.25rem;
      }
    }
  }
}
.quick-view-modal {
  padding-left: $px30;
  position: absolute;
  top: 0;
  z-index: 1;
  left: 70%;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  .main-content {
    background: $white;
    box-shadow: 0px $px4 $px54 rgba($black, 0.25);
    border-radius: $px10;
    padding: $px20 $px30;
    display: flex;
    height: $px365;
    &.loader-main-content {
      width: $px600;
    }
    .quickview-loader {
      width: 100%;
      height: 100%;
      position: relative;
      .loader {
        border: $px3 solid $light-border;
        border-bottom-color: transparent;
        border-radius: 50%;
        animation: 1s loader linear infinite;
        display: inline-block;
        width: 2em;
        height: 2em;
        color: inherit;
        vertical-align: middle;
        pointer-events: none;
        position: absolute;
        top: 50%;
        left: 45%;
        transform: translate(-50%, -50%);
      }
    }
    .left-part {
      width: $px112;
      border: $px1 solid $light-border;
      box-sizing: border-box;
      border-radius: $px4;

      .header {
        padding: $px10 0;
        text-align: center;

        span {
          font-size: $px12;
          line-height: $px15;
          letter-spacing: 0.5px;
          color: $font-color;
          text-transform: capitalize;
          font-weight: 500;
        }
      }

      ul {
        li {
          border-top: $px1 solid $light-border;
          display: block;
          text-align: center;
          padding: $px8 0;

          a {
            font-size: $px10;
            line-height: $px12;
            letter-spacing: 0.01em;
            color: $font-color;
            text-transform: capitalize;
            transition: all 0.5s ease;
          }

          &:hover,
          &.active {
            a {
              color: $color-primary;
              transition: all 0.5s ease;
            }
          }
        }
      }

      .footer {
        padding: $px10 0;
        text-align: center;
        background-color: var(--primary-color-1);

        span {
          font-size: $px12;
          line-height: $px15;
          letter-spacing: 0.5px;
          color: $color-primary;
          text-transform: capitalize;
          font-weight: 500;
        }
      }
    }
    .right-part {
      margin-left: $px30;
      width: $px470;
      @keyframes loader {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .quick-modal {
        display: none;
        &.active {
          display: flex;
          overflow: hidden;
          max-height: $px350;
          overflow-y: auto;
          &::-webkit-scrollbar {
            display: none;
          }
        }
      }
      .row {
        > div {
          &:nth-last-child(-n + 3) {
            .product-detail-box {
              margin-bottom: 0;
            }
          }
        }
      }

      .ratio_94 {
        .bg-size {
          border-radius: $px5 $px5 0 0;
          overflow: hidden;

          &:before {
            padding-top: 78%;
          }
        }
      }

      .product-detail-box {
        background: $white;
        border: $px1 solid rgba(var(--color-dark-border-source), 0.44);
        border-radius: $px4;
        overflow: unset;
        margin-bottom: $px20;
        // height:170px;
        height: calc(
          #{$px120} + (170 - 120) * ((100vw - #{$px320}) / (1920 - 320))
        );
        .product-details {
          padding: $px10;

          h5 {
            font-size: $px12;
            line-height: $px15;
            letter-spacing: 0.5px;
            color: $font-color;
            margin-bottom: $px6;
            max-width: $px220;
            font-weight: bold;
            text-transform: capitalize;
            height: 45px;
            overflow-y: auto;
            &::-webkit-scrollbar {
              display: none;
            }
          }

          h6 {
            font-size: $px12;
            line-height: $px15;
            letter-spacing: 0.5px;
            color: $font-color;
          }
        }
        .img-box {
          position: relative;
          .slider-label {
            background-color: $color-primary;
            position: absolute;
            left: -$px10;
            top: $px14;
            padding: $px2 $px10 $px4;
            border-radius: $px2;
            z-index: 1;

            span {
              font-weight: 600;
              letter-spacing: 0.5px;
              color: $white;
              font-size: $px8;
              line-height: $px15;
              text-transform: uppercase;

              &:after {
                position: absolute;
                content: '';
                left: $px1;
                top: -$px10;
                width: 0;
                height: 0;
                border-bottom: $px10 solid darken($primary-color, 30%);
                border-left: $px9 solid $transparent;
                z-index: -1;
              }
            }

            &.warning {
              background-color: $warning-color;

              span {
                &:after {
                  border-bottom: $px10 solid $warning-color;
                }
              }
            }

            &.tertiary {
              background-color: $color-tertiary;

              span {
                &:after {
                  border-bottom: $px10 solid darken($tertiary-color, 10%);
                }
              }
            }
          }
        }
      }
    }
  }
  &.left-part {
    left: unset;
    right: 70%;
    padding-left: 0;
    padding-right: $px30;
  }
  .not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: $px350;
  }
}
@media (max-width: 1367px) {
  .quick-view-modal {
    padding-left: $px10;
    .main-content {
      &.loader-main-content {
        width: $px500;
      }
      .left-part {
        width: $px100;
      }
      .right-part {
        width: $px390;
        margin-left: $px20;
      }
    }
    &.left-part {
      padding-right: $px10;
    }
  }
}
@media (max-width: 1199px) {
  .quick-view-modal {
    .main-content {
      &.loader-main-content {
        width: $px350;
      }
      .right-part {
        width: $px150;
        margin-left: $px20;
        /* width */
        ::-webkit-scrollbar {
          width: $px3;
        }
        /* Track */
        ::-webkit-scrollbar-track {
          background: #dce0e5;
          border-radius: $px6;
        }
        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: #b2becf;
          border-radius: $px4;
        }
        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: darken(#dce0e5, 0.2);
        }
        .quick-modal {
          max-height: $px380;
          overflow: auto;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .quick-view-modal {
    display: none;
  }
}
.body-rtl {
  .quick-view-modal {
    padding-right: $px30;
    position: absolute;
    left: unset;
    right: 70%;
  }
  .product-box {
    &.show-quickview {
      .quick-view-modal {
        left: unset;
        right: 100%;
      }
    }
  }
}
</style>
